
export default class SessionCache {

    static user = null;

    static isAuthenticated() {

        if (this.user == null) {
            return null;
        }
        else if (this.user['isAuthenticated']) {
            return true;
        }

        return false;
    }

    static isVerified() {

        return this.user?.isVerified;
    }

    static isPasswordUpdated() {

        return this.user?.passwordUpdated;
    }


    static getName() {
        if (this.user) {
            return this.user?.name;
        }

        return "";
    }

    static getUser() {
        return this.user
    }

    static getUserActions() {
        return this.user?.actions || [];
    }

    static getAllowedModule() {
        return this.user?.accessRights || {};
    }

    static setUser(obj) {

        if(obj === null) {
            this.user = null
            return;
        }

        let actions = [], accessRights = {}

        if (obj.types) {
            for (let i = 0; i < obj.types.length; i++) {
                actions.push(...obj.types[i].actions)
            }
        }

        actions.forEach(item => {
                accessRights[item.name] = item.name
        })

        if (!obj.showStudentPerformanceReport) {
            let filteredActions = actions.filter(item => item.name != 'PERFORMANCE_REPORT')
            actions = filteredActions
        }

        obj.accessRights = accessRights
        obj.actions = actions
        this.user = obj;
    }
};